import { httpClient } from '../httpClient';

interface IADISuggestCategoryResponse {
  offset: number;
  relatedResults: IRawADICategory[];
  results: IRawADICategory[];
  totalResults: number;
}

interface IRawADICategory {
  displayName: string;
  industryId: string;
  structureId: string;
  score: number;
  block: boolean;
  redirectUrl?: string;
  experiment: string;
}

interface IGetADICategoriesParams {
  query: string;
  limit?: number;
  sessionId: string;
}

interface IADICategory {
  displayName: string;
  industryId: string;
  structureId: string;
}

const SUGGESTED_ADI_CATEGORIES: IADICategory[] = [
  {
    displayName: 'Retail Store',
    industryId: '087d714d5f85b09c65b51e28',
    structureId: '073bd83d054dcff87fa0ef50',
  },
  {
    displayName: 'Yoga Studio',
    industryId: '92ddb10e7059f7749cd45db1',
    structureId: '89fa91123688531f0a4ba0ce',
  },
  {
    displayName: 'Photography Studio',
    industryId: '943fe987d03d8cbf1be42ad5',
    structureId: 'afee35922f1083c84a62b114',
  },
  {
    displayName: 'Food Blog',
    industryId: '1bc4097af1d4907daadf2cd1',
    structureId: 'b0a520919b99728bae200018',
  },
  {
    displayName: 'Production House',
    industryId: '363f5f768f1755fbd2cbd8cc',
    structureId: '59b02f109bae3a2f4eabd359',
  },
  // TODO: add more categories
];

async function getADICategories({
  query,
  sessionId,
  limit = 20,
}: IGetADICategoriesParams): Promise<IADICategory[]> {
  const response = await httpClient.get<IADISuggestCategoryResponse>(
    '_api/funnel-taxonomy-service/v1/business-term/search',
    {
      params: {
        q: query,
        editorSessionId: sessionId,
        limit,
        source: 'vmaf',
      },
    },
  );

  const results = response.data.results.length
    ? response.data.results
    : response.data.relatedResults;

  return results
    .filter((result) => !result.block)
    .map<IADICategory>(({ displayName, industryId, structureId }) => ({
      displayName,
      industryId,
      structureId,
    }));
}

export { SUGGESTED_ADI_CATEGORIES, getADICategories, IADICategory };
